import { CustomEventWithDetail, type Html, html, on, UnsafeHtml, View } from 'rune-ts';
import klass from './ButtonCTA.module.scss';
import { cx, cxIf } from '../util';

export interface CTAButtonProps {
  theme: 'brand' | 'filled' | 'tonal' | 'outline' | 'ghost' | 'greenery' | 'none';
  size?: 'xl' | 'l' | 'm' | 's';
  disabled?: boolean;
  text?: string | Html | UnsafeHtml;
  radius?: boolean;
  klass?: string;
  selected?: boolean;
  id?: number;
  onClick?: (view: View) => void;
  style?: string;
}

export class CTAButtonEvent extends CustomEventWithDetail<CTAButtonProps> {}

export class ButtonCTA extends View<CTAButtonProps> {
  override template() {
    const { style, selected, klass: customKlass, theme, radius, size, disabled, text } = this.data;

    const buttonClasses = cx(
      klass.cta_button,
      customKlass,
      theme && theme !== 'none' ? klass[`theme_${theme}`] : undefined,
      klass[`size_${size}`],
      cxIf(disabled, klass.disabled),
      cxIf(selected, klass.selected),
      cxIf(radius, klass.radius),
    );

    return html` <button class="${buttonClasses}" style=${style ?? ''}>${text}</button> `;
  }

  override onRender() {
    this.addEventListener('click', () => {
      this.dispatchEvent(CTAButtonEvent, { bubbles: true, detail: this.data });
    });
  }

  setDisable(disable: boolean) {
    this.data.disabled = disable;
    this.redraw();
  }

  @on('click')
  protected handleClick() {
    if (this.data.disabled) return;
    if (this.data.onClick) {
      this.data.onClick(this);
    }
  }

  setSelect(selected: boolean) {
    this.data.selected = selected;
    this.redraw();
  }

  setText(text: string | Html | UnsafeHtml) {
    this.data.text = text;
  }

  setTheme(theme: 'brand' | 'filled' | 'tonal' | 'outline' | 'ghost' | 'greenery' | 'none') {
    this.data.theme = theme;
  }
}
